import { FC } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";
import { useId } from "@react-aria/utils";

import Typography from "../../../typography/Typography";
import CheckInputBase from "../../CheckInputBase/CheckInputBase";

import {
	StyledRadioButtonInput,
	StyledRadioButtonCircle,
} from "./styling/RadioButton.styles";
import { RadioButtonProps } from "./RadioButton.types";

const RadioButton: FC<RadioButtonProps> = ({
	id,
	className,
	label,
	colorOn,
	checked,
	...props
}) => {
	const block = new BemIt("RadioButton");
	const uid = useId(id);
	return (
		<CheckInputBase className={addClass(className).after(block)} htmlFor={uid}>
			<StyledRadioButtonInput
				id={uid}
				type="radio"
				defaultChecked={checked}
				aria-label={label}
				{...props}
			/>
			<StyledRadioButtonCircle className={block.el("circle").out} />
			<Typography
				className={block.el("label").out}
				variant="body"
				colorOn={colorOn}
			>
				{label}
			</Typography>
		</CheckInputBase>
	);
};

export default RadioButton;
